import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import store from './Store/store'
import MovieItem from './MovieItem'
import {BrowserRouter, Route} from 'react-router-dom'



ReactDOM.render(
<BrowserRouter>
<Provider store={store}>
    <Route exact path='/' component={App}/>
    <Route exact path='/movie/:id' component={MovieItem}/>
</Provider>
</BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
